import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';


export function fetchRolesDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = "role/dropdown";

  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function saveRoles(app, dataToSave) {
  const { user={}, data } = dataToSave;

  // make empty strings as false,
  data.features.forEach((feat) => {
    if (feat.create === "") feat.create = false;
    if (feat.read === "") feat.read = false;
    if (feat.update === "") feat.update = false;
    if (feat.delete === "") feat.delete = false;
  });

  let rolesData = {
    doc_type: DocType.ROLES,
    name: util.toStringText(data.name),
    description: util.toStringText(data.description),
    features: data.features,
    active: util.toBoolean(data.active),
    system_defined: util.toBoolean(data.system_defined),
    is_admin: data.is_admin,
    role_authority: util.toObjectIds(
      data.role_authority,
      data.role_authority_ids,
      'role_id',
    ),

  };
  return common.saveDoc(app, {
    source: data,
    doc: rolesData,
    user
  });
}

export function deleteRoles(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.ROLES
  });
}

export function fetchRolesForEdit(app, params) {
  const { id } = params;
  const docType = DocType.ROLES;
  return common.getDoc(app, { id, docType }/*, {useElastic: true}*/);
}


export function getEmployeesData(app, data) {
  // const service = getRoleEmployeeService(app);
  // return service.find({ query: { ...data } });
  return common.getDocs(app, data);
}

export const getRoleEmployeeService = (app) => {
  let service = app.service('role-employee-service');
  return service;
}
